import type { Category, FlexboardType } from "@/backend/natsstubs/flexboard/models";

import type { ServerCategory, ServerFlexType } from "../serverModel";

export function mapApiFlexType(type: FlexboardType): ServerFlexType {
  return { id: type.id, name: type.name, background: type.background };
}

export function mapApiCategory(category: Category): ServerCategory {
  return { _id: category.id, name: category.name, board_ids: category.boardIds };
}
